export enum UserAccessLevel {
    MerchantUser = 0,
    MerchantAdmin = 1,
    Reseller = 2,
    Admin = 3,
  }